// GLSL shader（由 .glsl 迁移为 TS 模块）
export default /* glsl */ `// ============================================================
// GSplat Common - 公共 chunks 入口
// 对标 PlayCanvas gsplatCommon.js
// ============================================================
//
// 这个文件作为顶点着色器的入口点，包含所有必要的依赖
// 使用 #include 指令按正确的依赖顺序引入各个模块

// 基础结构和辅助函数（无依赖）
#include "gsplatStructsVS"
#include "gsplatQuatToMat3VS"
#include "gsplatHelpersVS"
#include "gsplatClipVS"

// 输出处理
#include "gsplatOutputVS"

// 数据源初始化
#include "gsplatSourceVS"

// gsplatSourceFormatVS 会按数据格式先展开 covariance/read 代码，
// 而真正的 modifier body 在下面才注入。GLSL ES 要求被调用函数在调用点
// 已有声明，因此先提供 prototype；后续 gsplatModifyVS 再提供默认或自定义实现。
void modifySplatScale(inout vec3 scale);

// 根据格式选择数据读取方式
#include "gsplatSourceFormatVS"

// 数据格式声明完成后再注入 effect/modifier，确保 extra stream helper 已可见。
#include "gsplatModifyVS"

// SH 评估（如果启用）
#include "gsplatEvalSHVS"

// 核心变换
#include "gsplatCenterVS"
#include "gsplatCornerVS"
`;
